import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M22 17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.5C2 7 4 5 6.5 5H18c2.2 0 4 1.8 4 4v8Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Polyline, { points: "15,9 18,9 18,11", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6.5 5C9 5 11 7 11 9.5V17a2 2 0 0 1-2 2v0", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "6", x2: "7", y1: "10", y2: "10", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Mailbox";
const Mailbox = memo(themed(Icon));
export {
  Mailbox
};
//# sourceMappingURL=mailbox.js.map
